// extracted by css-extract-rspack-plugin
export default {"container":"container--nmlEBi8TQEwz4TXk"};